<template>
    <form ref="form" role="form" class="form-register needs-validations">
        <p v-if="message" class="alert alert-success" v-html="message"></p>
        <p v-else-if="error" class="alert alert-danger" v-html="error"></p>
        <fieldset>
            <legend class="sr-only">Contact us</legend>
            <div class="row">
                <template v-for="field in _.get(config, 'fields', [])">
                    <div v-if="field.data_type == 'input-text'"
                        :key="field.name"
                        class="col-sm-12 col-xl-6">
                        <div class="form-group">
                            <label :for="getLabelId(field.name)" class="">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="getLabelId(field.name)"
                                :name="field.name"
                                :_placeholder="field.title"
                                :required="field.required"
                                type="text"
                                :class='[
                                    "form-control", "req",
                                    formError[field.name] ? "is-invalid" : ""
                                ]'>
                            <span v-if="formError[field.name]" class="invalid-feedback">
                                {{ _.first(formError[field.name]) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-email'"
                        :key="field.name"
                        class="col-sm-12 col-xl-6">
                        <div class="form-group">
                            <label :for="getLabelId(field.name)" class="">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="getLabelId(field.name)"
                                :name="field.name"
                                :_placeholder="field.title"
                                :required="field.required"
                                type="email"
                                :class='[
                                    "form-control", "req",
                                    formError[field.name] ? "is-invalid" : ""
                                ]'>
                            <span v-if="formError[field.name]" class="invalid-feedback">
                                {{ _.first(formError[field.name]) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-number'"
                        :key="field.name"
                        class="col-sm-12 col-xl-6">
                        <div class="form-group">
                            <label :for="getLabelId(field.name)" class="">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <input v-model="formData[field.name]"
                                :id="getLabelId(field.name)"
                                :name="field.name"
                                :_placeholder="field.title"
                                :required="field.required"
                                type="number"
                                :class='[
                                    "form-control", "req",
                                    formError[field.name] ? "is-invalid" : ""
                                ]'>
                            <span v-if="formError[field.name]" class="invalid-feedback">
                                {{ _.first(formError[field.name]) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'checkbox'"
                        :key="field.name"
                        class="col-sm-12 col-lsg-6 mb-4">
                        <div class="d-flex align-items-center">
                            <div class="checkbox">
                                <label  :for="field.name + '-' + field.id"
                                    class="container-checkbox">{{ field.title }}<sup v-if="field.required">*</sup>
                                    <input v-on:input="(e) => updateCheckbox(field.name, e)"
                                        :checked="formData[field.name]"
                                        :name="field.name"
                                        :_placeholder="field.title"
                                        :id="field.name + '-' + field.id"
                                        :required="field.required"
                                        :value="1"
                                        type="checkbox"
                                        class="mailinglist">
                                        <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'selectbox'"
                        :key="field.name"
                        class="col-sm-12 col-lg-6">
                        <div :class='[
                                  "form-group",
                                  formError[field.name] ? "is-invalid" : ""
                                ]'>
                            <label :for="getLabelId(field.name)" class="">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <select v-model="formData[field.name]"
                                :id="getLabelId(field.name)"
                                :name="field.name"
                                :required="field.required"
                                :data-title="field.title"
                                data-width="100%"
                                data-size="8"
                                data-style="btn-select"
                                :class='[
                                  "form-control", "selectpicker",
                                  formError[field.name] ? "is-invalid" : ""
                                ]'>
                                 <option v-for="(option, idx) in getSelectValues(field)"
                                        :key="`selOpt${idx}`"
                                        :value="option.length > 1 ? option[1] : option[0]">{{ option[0] }}</option>
                            </select>
                            <!-- {{  _.getSelectValues(field) }} -->
                            <span v-if="formError[field.name]" class="invalid-feedback">
                                {{ _.first(formError[field.name]) }}
                            </span>
                        </div>
                    </div>

                    <div v-if="field.data_type == 'radio-button'"
                      :key="field.name"
                      class="col-sm-12 col-lg-6">
                      <div class="form-group">
                        <label class="d-block">{{ field.title }}</label>
                        <div v-for="(option,index) in getRadioValues(field)"
                            :key="`radio-${index}`"
                            class="form-check form-check-inline">
                            <input
                                v-model="formData[field.name]"
                                :id="getLabelId(field.name+index)"
                                :name="field.name"
                                :value="option"
                                type="radio"
                                :class='[
                                "form-check-input",
                                formError[field.name] ? "is-invalid" : ""
                            ]'>
                          <label :for="getLabelId(field.name+index)" class="form-check-label">
                          {{ option }}
                          </label>
                        </div>
                        <span v-if="formError[field.name]" class="invalid-feedback">
                            {{ _.first(formError[field.name]) }}
                        </span>
                      </div>
                    </div>


                    <div v-if="field.data_type == 'textarea'"
                        :key="field.name"
                        class="col-sm-12">
                        <div class="form-group">
                            <label :for="getLabelId(field.name)">{{ field.title }}<sup v-if="field.required">*</sup></label>
                            <textarea v-model="formData[field.name]"
                                :name="field.name"
                                :id="getLabelId(field.name)"
                                :_placeholder="field.title"
                                :required="field.required"
                                :class='[
                                    "form-control",
                                    formError[field.name] ? "is-invalid" : ""
                                ]'
                                rows="8"
                                ></textarea>
                            <span v-if="formError[field.name]" class="invalid-feedback">
                                {{ _.first(formError[field.name]) }}
                            </span>
                        </div>
                    </div>
                </template>
            </div>
        </fieldset>
        <div class="text-center">
            <button disabled :class="[
                    'btn', 'btn-blossom', 'btn-md','disabled',
                    loading ? '' : 'd-none'
                ]">Please wait...</button>
            <button :data-sitekey="recaptcha"
                    :class="['btn', 'btn-blossom', 'btn-md', loading ? 'd-none' : '']"
                    ref="form-btn"
                    data-theme="light"
                    type="button"
                    >Submit</button>
        </div>


    </form>
</template>
<script>
import jsonp from 'jsonp';
import UtilsMixin from './UtilsMixin';
import FormMixin from '72cms-orm/components/FormValidationMixin';

export default{
    data() {
        return {
            recaptcha: window.env.GOOGLE_RECAPTCHA_KEY,
            message: '',
            error: '',
        }
    },

    component: {

    },

    mixins: [
        UtilsMixin,
        FormMixin,
    ],

    created() {
        this.config.action = this.config.template == 'Subscribe' ? 'SENDSUBSCRIBER' : 'SENDENQUIRY';
        this.config.ajax = 'customer/post-form';
    },

    mounted() {

    },

    computed: {
         formConfig() {
            return _.get(this, 'config', {});
        },
    },

    methods: {
        initRecaptchaButton() {
            // Check if the reCAPTCHA has been rendered
            if (this.$refs['form-btn'].hasAttribute('data-recaptcha')) {
                return;
            }

            grecaptcha.render(this.$refs['form-btn'], {
                sitekey: this.recaptcha,
                callback: this.submitForm,
            });

            this.$refs['form-btn'].setAttribute('data-recaptcha', 'true');
        },

        getRadioValues(field) {
            return _.isArray(field.values) ? field.values : _.split(field.values, '\n');
        },

         getSelectValues(field) {
            if (_.isArray(field.values)) return _.isArray(field.values);

            let values = _.split(field.values, '\n');

            // check if | pipe exists
            return _.map(values, (item) => {
                let temp = _.split(item, '|');
                return temp;
            }).values();
            // return _.isArray(field.values) ? field.values : _.split(field.values, '\n');
        },


        submitForm(token = null) {
            if (this.loading) {
                return;
            }

            // store formdata in constant before submitting
            const formData = this.getRequestData();

            return this.submit(token)
                .finally(() => {
                    let form = this.$refs['form'];
                    let fieldError = _.chain(this.formError)
                        .toPairs()
                        .first()
                        .first()
                        .value();

                    if (fieldError) {
                        $(form).find(`[name="${fieldError}"]`).focus();
                        } else {
                        // Push to SharpSpring if form complete
                        this.sharpspringPush(
                            _.get(this.formConfig, 'sharpspring_url'),
                            _.get(this.formConfig, 'sharpspring_endpoint'),
                            formData
                        );
                    }

                    if ($(form).closest('.modal').length) {
                        // do not scroll
                    } else {
                        this.scrollTo(form);
                    }
                })
        },

        scrollTo(elm) {
            var offsetSize = $('.navbar--main').height() + 50;
            return $('html, body').animate({
                scrollTop: $(elm).offset().top - offsetSize
            }, 1000);
        },

        updateCheckbox(fieldname, e) {
            let value = e.target.checked * 1;
            this.formData[fieldname] = value;
        },

        sharpspringPush(url, endpoint, formData = {}) {

            if (
                _.isNull(url) || _.isEmpty(url) ||
                _.isNull(endpoint) || _.isEmpty(endpoint)
            ) {
                return false;
            }

            let formFields = {};
            for (const key in formData) if (key in this.formData) formFields[key] = formData[key];

            let ssTracking = this.getCookie('__ss_tk');
            let params = new URLSearchParams(_.assign({}, formFields, { trackingid__sb: ssTracking }));

            return jsonp(`${url}${endpoint}/jsonp/?${params.toString()}`, null, (err, data) => {
                console.log(err, data);
            });
        },

        getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },

        getLabelId(name) {
            return `${this.config.formId}-${name}`
        }
    },
}
</script>

<style scoped>

</style>
